import { Component } from '@angular/core';
import { soundpostAccountingPeriodEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Accounting Periods') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostaccountingperiod-form',
    templateUrl: './soundpostaccountingperiod.form.component.html'
})
export class soundpostAccountingPeriodFormComponent extends BaseFormComponent {
    public record!: soundpostAccountingPeriodEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reportRuns', sectionName: 'Report Runs', isExpanded: false },
            { sectionKey: 'postingGroups', sectionName: 'Posting Groups', isExpanded: false },
            { sectionKey: 'reportOutputProductGLActivitySummaries', sectionName: 'Report Output Product GL Activity Summaries', isExpanded: false },
            { sectionKey: 'reportOutputAgreementGLActivitySummaries', sectionName: 'Report Output Agreement GL Activity Summaries', isExpanded: false },
            { sectionKey: 'reportOutputAccountActivitySummaries', sectionName: 'Report Output Account Activity Summaries', isExpanded: false }
        ]);
    }
}

